import { useConfig } from 'core/common/hooks';
import { TechLayout } from 'core/common/ui/layouts';
import { Typography } from 'core/common/ui/ui-kit';
import { useContactUs } from './useContactUs';
import { LinkStyled } from './styled';

export const ContactUs = () => {
  const { supportCenter, supportEmail } = useConfig();
  useContactUs();

  return (
    <TechLayout>
      <Typography textAlign="center" gutterBottom variant="h1">
        Contact Us
      </Typography>
      <Typography variant="bodyMediumRegular">
        We will be glad to assist you via email{' '}
        <LinkStyled href={`mailto:${supportEmail}`} target="_blank">
          {supportEmail}
        </LinkStyled>{' '}
        . You can also send your question and feedback to{' '}
        <LinkStyled href={supportCenter} target="_blank">
          Support center
        </LinkStyled>
      </Typography>
    </TechLayout>
  );
};
